export default {
      id: "ic_ecouter-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_ecouter-usage",
      toString: function () {
        return this.url;
      }
    }